(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
class CartNote extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('change', debounce((event) => {
      const body = JSON.stringify({ note: event.target.value });
      fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
    }, 300))
  }
}
customElements.define('cart-note', CartNote);


// ✅ Minimum Order Validation
document.addEventListener("click", function(e) {

  if (e.target.closest(".cart__checkout-button")) {

    e.preventDefault();

    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {

        var minAmount = 1000; // change here
        var cartTotal = cart.total_price / 100;
        var messageBox = document.getElementById("minimum-order-message");

        if (cartTotal < minAmount) {

          var remaining = minAmount - cartTotal;

          messageBox.innerHTML = "You are ₹" + remaining.toFixed(0) + 
            " away from minimum order amount of ₹" + minAmount + ".";

          messageBox.style.display = "block";
          messageBox.style.color = "#b00020";
          messageBox.style.fontWeight = "600";
          messageBox.style.background = "#ffe6e6";
          messageBox.style.padding = "12px";
          messageBox.style.borderRadius = "6px";

          messageBox.scrollIntoView({ behavior: "smooth", block: "center" });

        } else {

          window.location.href = "/checkout";

        }

      });
  }

});



// ✅ Minimum Order Validation - FORM SUBMIT METHOD
document.addEventListener("DOMContentLoaded", function () {

  var cartForm = document.querySelector("form#cart");
  var messageBox = document.getElementById("minimum-order-message");
  var minAmount = 1000; // change amount here

  if (!cartForm) return;

  cartForm.addEventListener("submit", function (e) {

    fetch("/cart.js")
      .then(res => res.json())
      .then(cart => {

        var cartTotal = cart.total_price / 100;

        if (cartTotal < minAmount) {

          e.preventDefault();

          var remaining = minAmount - cartTotal;

          messageBox.innerHTML =
            "You are ₹" + remaining.toFixed(0) +
            " away from minimum order amount of ₹" + minAmount + ".";

          messageBox.style.display = "block";
          messageBox.style.color = "#b00020";
          messageBox.style.fontWeight = "600";
          messageBox.style.background = "#ffe6e6";
          messageBox.style.padding = "12px";
          messageBox.style.borderRadius = "6px";

          messageBox.scrollIntoView({
            behavior: "smooth",
            block: "center"
          });

        } else {

          window.location.href = "/checkout";

        }

      });

    e.preventDefault(); // always prevent default first

  });

});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 50))
    }
  }
  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
              window.initSwatchOptionImage();
              window.initVariantChanger(this);
              window.initTooltips([].slice.call(this.querySelectorAll('[data-bs-toggle="tooltip"]')));
              window.initCompare();
            }
      const   swiperItems = document.querySelectorAll('.product-recommendations'),
              sliderOptions = $(swiperItems).attr('data-slider-options'),
               slideroptionConfig = $.parseJSON(sliderOptions),
               recommedndationSlider = new Swiper(".product-recommendations", slideroptionConfig);
               $.getScript(window.location.protocol + "//productreviews.shopifycdn.com/embed/loader.js"); 
          })
          .catch(e => {
            console.error(e);
          });
      }
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
